const DEVICE_OPTIONS = [
  { key: "desktop", label: "Desktop" },
  { key: "tablet", label: "Tablet" },
  { key: "mobile", label: "Celular" },
];

function DeviceIcon({ type }) {
  if (type === "desktop") {
    return (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="3" width="20" height="13" rx="2" />
        <line x1="8" y1="21" x2="16" y2="21" />
        <line x1="12" y1="16" x2="12" y2="21" />
      </svg>
    );
  }

  if (type === "tablet") {
    return (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
        <rect x="4" y="2" width="16" height="20" rx="2" />
        <line x1="12" y1="18" x2="12.01" y2="18" />
      </svg>
    );
  }

  return (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
      <rect x="6" y="2" width="12" height="20" rx="2" />
      <line x1="12" y1="18" x2="12.01" y2="18" />
    </svg>
  );
}

export default function PreviewDeviceTabs({ value, onChange }) {
  return (
    <div className="flex items-center gap-1">
      {DEVICE_OPTIONS.map((device) => (
        <button
          key={device.key}
          type="button"
          onClick={() => onChange(device.key)}
          title={device.label}
          className={`flex flex-col items-center gap-0.5 px-3 py-1.5 rounded-lg transition-all text-xs font-medium ${
            value === device.key
              ? "text-slate-900 bg-slate-200"
              : "text-slate-400 hover:text-slate-700 hover:bg-gray-100"
          }`}
        >
          <DeviceIcon type={device.key} />
          <span>{device.label}</span>
        </button>
      ))}
    </div>
  );
}
